export default "__VITE_ASSET__defaf128__"